import styled from "styled-components";
import type { StyledTrProps } from "@/types/DataTableTypes";

export const Row = styled.div<StyledTrProps>`
  .td:first-child {
    ${(props) =>
      props.$isShowDecoratorColor
        ? `border-left: 5px solid ${props.$decoratorColor || "transparent"}`
        : ""};
    ${(props) => (props.$isShowDecoratorColor ? "padding-left: 0.25rem" : "")};
  }
`;

export const DynamicTableStyles = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  /* Main scrolling container - fixed height from inline style takes priority */
  .dynamic-table-scroll-container {
    overflow: auto;
    flex: 0 0 auto; /* Don't grow or shrink, use the explicit height */
    min-height: 0;
  }

  .table {
    border-spacing: 0;
    min-height: 1px;

    .tr {
      &.odd {
        background: #f9fafa;
        .td {
          background: #f9fafa;
        }
      }
      &.even {
        background: #fff;
        .td {
          background: #fff;
        }
      }
    }

    .mh-30 {
      min-height: 30px;
    }

    .th {
      font-weight: 500;
      border-bottom: 2px solid #f3f5f6;
      padding: 0.5rem;
      background-color: white;

      .resizer {
        display: inline-block;
        width: 10px;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        z-index: 1;
        touch-action: none;
        border-left: 1px solid #424b59 !important;
        cursor: e-resize !important;
        opacity: 0;

        :hover {
          opacity: 0.5;
        }

        &.isResizing {
          opacity: 0.5;
        }
      }

      .sortIcon {
        color: grey;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background-color: #eff3f4;
      }
    }

    .td {
      word-break: break-word;
    }

    .tbody {
      position: relative;
      z-index: 1;
    }
  }

  .dynamic-table-header {
    background-color: white;

    .tr {
      background-color: white;
    }
  }

  /* Footer styling - stays at bottom, outside scroll area */
  .dynamic-table-footer {
    flex-shrink: 0;
    background-color: white;
    border-top: 1px solid #b8bfca;
    padding-top: 0.5rem;
  }
`;
